window.commentTemplate = `
    <div class="frame-com-item flex">
        <div class="per-avatar02">
            <img src="AvatarPathHolder" />
        </div>
        <div class="fill com_item_box">
            <div class="com-lv1">
                <div class="frame-com-mes">
                    <a href="#"><b>FullnameHolder</b></a>
                    <div>TextHolder</div>
                </div>
                <div>
                    <div class="frame-com-acts">
                        <span class="frame-time">vài giây trước</span>
                        <span class="frame-like like_com d-none">Like</span>
                        <span class="frame-reply reply_com d-none">Reply</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;
const commentFormTemplate = `
<div class="comment-form">
    <div class="per-avatar02">
        <img src="images/avatar01.jpg" />
    </div>
    <div class="fill frame-com-box">
        <div class="fill com-textarea-over">
            <textarea placeholder="Bình luận của bạn" class="auto-area post_com" rows="1"></textarea>
        </div>
        <div class="com-button-over">
            <button class="submit-btn no-bg send_com">
                <svg height="20px" viewBox="0 0 24 24" width="20px">
                    <title>Press Enter to send</title>
                    <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill="var(--chat-composer-button-color)"></path>
                </svg>
            </button>
        </div>
    </div>
</div>
`;
window.subcomTemplate = `
    <div class="frame-com-item flex">
        <div class="per-avatar03">
            <img src="AvatarPathHolder" />
        </div>
        <div class="">
            <div class="frame-com-mes">
                <a href="#"><b>FullnameHolder</b></a>
                <div>TextHolder</div>
            </div>
            <div>
                <div class="frame-com-acts">
                    <span class="frame-time">vài giây trước</span>
                    <span class="frame-like like_com d-none">Like</span>
                    <span class="frame-reply reply_com">Reply</span>
                </div>
            </div>
        </div>
    </div>
`;

window.subcomFormTemplate = `
<div class="comment-form">
    <div class="per-avatar03">
        <img src="images/avatar01.jpg">
    </div>
    <div class="fill frame-com-box">
        <div class="fill com-textarea-over">
            <textarea placeholder="Trả lời" class="auto-area post_com" rows="1"></textarea>
        </div>
        <div class="com-button-over">
            <button class="submit-btn no-bg send_subcom">
                <svg class="xsrhx6k" height="20px" viewBox="0 0 24 24" width="20px">
                    <title>Press Enter to send</title>
                    <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill="var(--chat-composer-button-color)"></path>
                </svg>
            </button>
        </div>
    </div>
</div>
`;
const myMessageTemplate = `
    <div class="per-item per-r">
        <span class="mes">TextHolder</span>
    </div>
`;
const contactMessageTemplate = `
    <div class="per-item per-l">
        <span class="mes">TextHolder</span>
    </div>
`;
const likeCommentTemplate = `
    <span class="like_com_num_over box-like">
        <span>
            <span class="img-like ">
                <img height="18" role="presentation" width="18" src="data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint0_linear_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint1_radial_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint2_radial_15251_63610)' fill-opacity='.5'/%3E%3Cpath d='M7.3014 3.8662a.6974.6974 0 0 1 .6974-.6977c.6742 0 1.2207.5465 1.2207 1.2206v1.7464a.101.101 0 0 0 .101.101h1.7953c.992 0 1.7232.9273 1.4917 1.892l-.4572 1.9047a2.301 2.301 0 0 1-2.2374 1.764H6.9185a.5752.5752 0 0 1-.5752-.5752V7.7384c0-.4168.097-.8278.2834-1.2005l.2856-.5712a3.6878 3.6878 0 0 0 .3893-1.6509l-.0002-.4496ZM4.367 7a.767.767 0 0 0-.7669.767v3.2598a.767.767 0 0 0 .767.767h.767a.3835.3835 0 0 0 .3835-.3835V7.3835A.3835.3835 0 0 0 5.134 7h-.767Z' fill='%23fff'/%3E%3Cdefs%3E%3CradialGradient id='paint1_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90 .0005 8) scale(7.99958)'%3E%3Cstop offset='.5618' stop-color='%230866FF' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%230866FF' stop-opacity='.1'/%3E%3C/radialGradient%3E%3CradialGradient id='paint2_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(45 -4.5257 10.9237) scale(10.1818)'%3E%3Cstop offset='.3143' stop-color='%2302ADFC'/%3E%3Cstop offset='1' stop-color='%2302ADFC' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='paint0_linear_15251_63610' x1='2.3989' y1='2.3999' x2='13.5983' y2='13.5993' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2302ADFC'/%3E%3Cstop offset='.5' stop-color='%230866FF'/%3E%3Cstop offset='1' stop-color='%232B7EFF'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E">
            </span>
            <span class="like_com_num">0</span>
        </span>
    </span>
`;